import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const GalleryWindow = ({ isGalleryOpen, setIsGalleryOpen, zFILO, addToZFILO, removeFromZFILO }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const zIndex = zFILO.indexOf('gallery') !== -1 ? 1000 + zFILO.indexOf('gallery') : 1000;

    const handleClose = () => {
        setIsGalleryOpen(false);
        removeFromZFILO('gallery');
        navigate('/');
    };

    const handleMinimize = () => {
        setIsGalleryOpen(false);
        removeFromZFILO('gallery');
        navigate('/');
    };

    if (!isGalleryOpen) return null;

    return (
        <>
            <Helmet>
                <title>Gallery | We Are A Site</title>
                <meta name="description" content="Explore our gallery of website designs and visual inspiration for your future site. See what we can bring to life." />
            </Helmet>

            <div className='GalleryWindow DesktopWindow' style={{ zIndex }}>
                <div className='GalleryWindowTitleBar DesktopWindowTitleBar'>
                    <span className='Title'>Gallery</span>
                    <div className='ResizeButtons'>
                        <img src='/images/MinimizeIcon.png' alt='Minimize' onClick={handleMinimize} />
                        <img src='/images/MaximizeIcon.png' alt='Maximize' />
                        <img src='/images/SystemMessageCloseButton.png' alt='Close' onClick={handleClose} />
                    </div>
                </div>
                <div>
                    Coming Soon . . .
                </div>
            </div>
        </>
    );
};

export default GalleryWindow;
